import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';
import classNames from 'classnames';
import cogoToast from 'cogo-toast';

import {
  blacklistedMenteeDetailSelector,
  BLACKLIST_MANAGE_MODAL_STAGES,
  setPersonalisedMenteeEmailersManageModalStage,
  useManageBlacklistMutation,
} from 'features/communicationManagement';
import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import styles from './PersonalisedMenteeEmailersManageConfirmButton.module.scss';

export default function PersonalisedMenteeEmailersManageConfirmButton() {
  const dispatch = useDispatch();
  const snoozeLearnerDetail = useSelector(blacklistedMenteeDetailSelector);

  const [createRequestManage, { isSuccess, isLoading, error }] =
    useManageBlacklistMutation();

  const handleConfirmClick = useCallback(() => {
    createRequestManage(snoozeLearnerDetail);
  }, [createRequestManage, snoozeLearnerDetail]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Email notifications for the learner are disabled');
      dispatch(
        setPersonalisedMenteeEmailersManageModalStage(
          BLACKLIST_MANAGE_MODAL_STAGES.close
        )
      );
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error?.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [error]);

  return (
    <Tappable
      className={classNames(styles.action, 'p-v-xxs', 'm-t-m')}
      onClick={handleConfirmClick}
      disabled={isLoading}
    >
      Confirm
    </Tappable>
  );
}
